// extracted by mini-css-extract-plugin
export default {"box":"CheckBoxFormik_box__mB0qQ","boxPre":"CheckBoxFormik_boxPre__yMq9m","custom_checkbox":"CheckBoxFormik_custom_checkbox__JDUoN"};